var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no-padding"},[_c('label',{staticClass:"question-label"},[_vm._v(_vm._s(_vm.item.name))]),_c('p',[_vm._v("This is a file upload")])])
}
var staticRenderFns = []

export { render, staticRenderFns }